import React, { useCallback, useEffect, useState } from 'react';
import { ProductCatalogAttributeSelectionType } from '@graphql/generated';
import { RangeValue } from '../../../RangeInput';
import { getComposedStringFromRange } from '../../../../utils/priceRange';
import { FilterItemVo } from '../ListCheckboxRow';
import { BUCKETED_CUSTOM_CODE } from '../RefinementFacetPriceBuckets/RefinementFacetPriceBuckets.controller';
import { RefinementFacetPriceRangeProps } from './RefinementFacetPriceRange';

export const useRefinementFacetPriceRange = ({ filter, onFilterSelect }: RefinementFacetPriceRangeProps) => {
  const { attributes, selectedPriceRange } = filter;

  const [currentPriceRange, setCurrentPriceRange] = useState<RangeValue>({
    min: selectedPriceRange?.minValueInMinorUnits ? selectedPriceRange.minValueInMinorUnits / 100 : undefined,
    max: selectedPriceRange?.maxValueInMinorUnits ? selectedPriceRange.maxValueInMinorUnits / 100 : undefined,
  });

  useEffect(() => {
    setCurrentPriceRange({
      min: selectedPriceRange?.minValueInMinorUnits ? selectedPriceRange.minValueInMinorUnits / 100 : undefined,
      max: selectedPriceRange?.maxValueInMinorUnits ? selectedPriceRange.maxValueInMinorUnits / 100 : undefined,
    });
  }, [selectedPriceRange]);

  const [currentBucketOptions, setCurrentBucketOptions] = useState<FilterItemVo[]>(attributes);

  useEffect(() => {
    setCurrentBucketOptions(attributes);
  }, [attributes]);

  const handlePriceChange = useCallback(
    (value: RangeValue) => {
      const filterArgs = {
        compositeCode: ProductCatalogAttributeSelectionType.priceRange,
        value: getComposedStringFromRange(value),
      };
      onFilterSelect({ selectionType: ProductCatalogAttributeSelectionType.priceRange, filterArgs });
      if (value.min !== undefined || value.max !== undefined) {
        setCurrentBucketOptions(curr => {
          return curr.map(option => {
            if (option.compositeCode === BUCKETED_CUSTOM_CODE) {
              return { ...option, isActive: true };
            }
            return { ...option, isActive: false };
          });
        });
      }
    },
    [onFilterSelect],
  );

  const handleBucketChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.dataset.itemId) return;
    const filterArgs = {
      compositeCode: event.target.dataset.itemId,
      value: true,
    };
    onFilterSelect({ selectionType: ProductCatalogAttributeSelectionType.priceBucket, filterArgs });
    setCurrentPriceRange({ min: undefined, max: undefined });
  };

  return { currentPriceRange, handlePriceChange, currentBucketOptions, handleBucketChange };
};
